import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import ChatBot from '../components/support/ChatBot';
import ContactForm from '../components/support/ContactForm';
import ContactInfo from '../components/support/ContactInfo';
import FAQ from '../components/support/FAQ';
import { PageHero } from '../components/ui/PageElements';

const SupportPage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('chat');
  const tabs = [
    { id: 'chat', label: t('design.support.liveSupport') },
    { id: 'faq', label: t('design.support.faq') },
    { id: 'contact', label: t('design.support.contactForm') }
  ];

  return (
    <Layout>
      <PageHero
        eyebrow={t('design.support.heroEyebrow')}
        title={t('design.support.heroTitle')}
        description={t('design.support.heroDescription')}
      />

      <section className="content-width pb-8">
        <div className="soft-panel p-6 sm:p-8">
          <div className="flex flex-wrap gap-3">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={activeTab === tab.id ? 'btn-primary' : 'btn-ghost'}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="mt-8">
            {activeTab === 'chat' ? <ChatBot /> : null}
            {activeTab === 'faq' ? <FAQ /> : null}
            {activeTab === 'contact' ? <ContactForm /> : null}
          </div>
        </div>
      </section>

      <section className="content-width pb-12">
        <ContactInfo />
      </section>
    </Layout>
  );
};

export default SupportPage;
